/**
 * 封装scheme协议
 * 详细参数见：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=12222556
 * 使用方法如：schemes.jump('/beatles_homepage', { userrole: 2 }); 跳到车主tab
 */
import {
  obj2Query,
  inBlord
} from './util';

import {
  getWindow
} from '../util';
let theWindow = getWindow();

let schemes = {};

// scheme协议域名
const protocolBlord = 'dhitch:'; // 顺风车独立端协议
const protocolDidi = 'diditravel:'; // 滴滴端协议
const schemeProtocol = inBlord() ? protocolBlord : protocolDidi;
const schemeOrigin = schemeProtocol + '//com.didi.passengerapp';

/**
 * 跳转scheme
 * @param {String} path scheme的路径，即在diditravel://com.didi.passengerapp之后的path，这样可以自由扩展path不必修改bridge
 * @param {Object} params 传递的参数，会自动转为query
 */
schemes.jump = function (path, params) {
  params = params || {};
  params.productid = 259;
  const query = obj2Query(params);
  const urlScheme = schemeOrigin + path;
  theWindow.location.href = urlScheme + '?' + query;
};

export default schemes;



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/schemes.js